import React, { useState } from 'react';
import { ExternalLink, Lock, X, Check, Plus, ToggleRight, ToggleLeft, ChevronRight, Trash2, Globe, ShieldCheck, AlertCircle, Clock, CheckCircle, FileCheck, GraduationCap, FileText, Upload } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
import { ImageUpload } from '../ui/ImageUpload';
interface ProfileTabProps {
  showToast: (msg: string) => void;
  onNavigate: (page: string) => void;
}
export function ProfileTab({
  showToast,
  onNavigate
}: ProfileTabProps) {
  const [showServices, setShowServices] = useState(true);
  const [showEducation, setShowEducation] = useState(true);
  const [showSchedule, setShowSchedule] = useState(true);
  const [showFaq, setShowFaq] = useState(true);
  const [showContacts, setShowContacts] = useState(true);
  const [collapsedSections, setCollapsedSections] = useState<Record<string, boolean>>({
    contacts: false,
    services: false,
    education: true,
    schedule: false,
    faq: true
  });
  const toggleCollapse = (section: string) => {
    setCollapsedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };
  const [verificationStatus, setVerificationStatus] = useState<'unverified' | 'pending' | 'verified'>('unverified');
  const [faqItems, setFaqItems] = useState([{
    id: 1,
    question: 'Как проходит видео-консультация?',
    answer: 'Созваниваемся в Zoom/Google Meet. Я заранее готовлю карту. Во время звонка разбираем все аспекты, после — отправляю запись и рекомендации.'
  }, {
    id: 2,
    question: 'Сколько длится разбор натальной карты?',
    answer: 'Видео-консультация длится 60 минут. Письменный разбор готовится 2-3 дня и включает PDF-документ на 15-20 страниц.'
  }]);
  const [serviceItems, setServiceItems] = useState([{
    id: 1,
    name: 'Разбор натальной карты (Видео)',
    price: '5000',
    duration: '60 мин'
  }, {
    id: 2,
    name: 'Соляр на год (Чат)',
    price: '4000',
    duration: '3 дня'
  }]);
  const [scheduleDays, setScheduleDays] = useState([true, true, true, true, true, false, false]);
  const [scheduleFrom, setScheduleFrom] = useState('10:00');
  const [scheduleTo, setScheduleTo] = useState('19:00');
  const [educationItems, setEducationItems] = useState([{
    id: 1,
    institution: 'Московская Академия Астрологии',
    program: 'Базовый и продвинутый курс',
    years: '2016-2018'
  }]);
  const [specializations, setSpecializations] = useState(['Западная астрология', 'Натальная карта', 'Прогностика', 'Синастрия']);
  const [newSpecInput, setNewSpecInput] = useState('');
  const [showSpecInput, setShowSpecInput] = useState(false);
  return <div className="space-y-6" data-id="element-12347">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6" data-id="element-12348">
        <div data-id="element-12349">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-12350">
            Редактирование профиля
          </h2>
          <p className="text-sm text-slate-500 mt-1" data-id="element-12351">
            Настройте информацию, которая будет видна клиентам
          </p>
        </div>
        <Button variant="outline" icon={<ExternalLink className="w-4 h-4" data-id="element-12353" />} onClick={() => onNavigate('astrologer-profile')} data-id="element-12352">
          Посмотреть профиль
        </Button>
      </div>

      {/* Основная информация */}
      <Card padding="lg" data-id="element-12354">
        <div className="flex justify-between items-center mb-6" data-id="element-12355">
          <h3 className="font-bold text-slate-900" data-id="element-12356">Основная информация</h3>
          <Badge variant="neutral" className="bg-slate-100" data-id="element-12357">
            <Lock className="w-3 h-3 mr-1" data-id="element-12358" /> Обязательный блок
          </Badge>
        </div>
        <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-12359">
          <div className="flex flex-col items-center gap-2 w-32" data-id="element-12360">
            <ImageUpload label="" value="" onChange={() => {}} height="h-32" className="w-32" data-id="element-12361" />
            <span className="text-xs text-slate-400" data-id="element-12362">Фото профиля</span>
          </div>
          <div className="flex-1 space-y-4" data-id="element-12363">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-12364">
              <Input label="Имя" defaultValue="Елена" data-id="element-12365" />
              <Input label="Фамилия" defaultValue="Смирнова" data-id="element-12366" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-12367">
              <Input label="Опыт работы (лет)" type="number" defaultValue="8" data-id="element-12368" />
              <Input label="Языки консультаций" defaultValue="Русский, Английский" data-id="element-12369" />
            </div>
            <div data-id="element-12370">
              <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12371">
                Специализации
              </label>
              <div className="flex flex-wrap gap-2 mb-2" data-id="element-12372">
                {specializations.map(tag => <Badge key={tag} variant="neutral" className="flex items-center gap-1 pr-1" data-id="element-12373">
                    {tag}{' '}
                    <X className="w-3 h-3 cursor-pointer hover:text-rose-500" onClick={() => {
                  setSpecializations(prev => prev.filter(s => s !== tag));
                  showToast('Специализация удалена');
                }} data-id="element-12374" />
                  </Badge>)}
                {showSpecInput ? <div className="flex items-center gap-1" data-id="element-12375">
                    <input type="text" value={newSpecInput} onChange={e => setNewSpecInput(e.target.value)} placeholder="Название..." className="rounded-lg border-slate-200 px-2 py-1 border focus:ring-primary focus:border-primary outline-none text-xs w-36" autoFocus onKeyDown={e => {
                  if (e.key === 'Enter' && newSpecInput.trim()) {
                    setSpecializations(prev => [...prev, newSpecInput.trim()]);
                    setNewSpecInput('');
                    setShowSpecInput(false);
                    showToast('Специализация добавлена');
                  }
                  if (e.key === 'Escape') {
                    setShowSpecInput(false);
                    setNewSpecInput('');
                  }
                }} data-id="element-12376" />
                    <button onClick={() => {
                  if (newSpecInput.trim()) {
                    setSpecializations(prev => [...prev, newSpecInput.trim()]);
                    setNewSpecInput('');
                    setShowSpecInput(false);
                    showToast('Специализация добавлена');
                  }
                }} className="p-1 text-emerald-500 hover:text-emerald-700" data-id="element-12377">
                      <Check className="w-4 h-4" data-id="element-12378" />
                    </button>
                    <button onClick={() => {
                  setShowSpecInput(false);
                  setNewSpecInput('');
                }} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-12379">
                      <X className="w-4 h-4" data-id="element-12380" />
                    </button>
                  </div> : <Badge variant="outline" className="border-dashed cursor-pointer hover:bg-slate-50" onClick={() => setShowSpecInput(true)} data-id="element-12381">
                    <Plus className="w-3 h-3 mr-1" data-id="element-12382" /> Добавить
                  </Badge>}
              </div>
            </div>
          </div>
        </div>
        <div data-id="element-12383">
          <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12384">
            О себе
          </label>
          <textarea className="w-full rounded-xl border-slate-200 px-4 py-3 border focus:ring-primary focus:border-primary outline-none text-sm" rows={5} defaultValue="Привет! Я Елена, профессиональный астролог с 8-летним стажем. Моя цель — перевести сложный язык звёзд на понятный человеческий. В своей работе я использую методы классической западной астрологии, подкрепленные знаниями в области психологии." data-id="element-12385" />
        </div>
      </Card>

      {/* Контакты и соцсети */}
      <Card padding="md" className={`transition-all duration-300 ${!showContacts ? 'opacity-60 bg-slate-50' : ''}`} data-id="element-12386">
        <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleCollapse('contacts')} data-id="element-12387">
          <h3 className="font-bold text-slate-900" data-id="element-12388">Контакты и соцсети</h3>
          <div className="flex items-center gap-4" data-id="element-12389">
            <button onClick={e => {
            e.stopPropagation();
            setShowContacts(!showContacts);
          }} className="flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-12390">
              {showContacts ? <>
                  <ToggleRight className="w-6 h-6 text-emerald-500" data-id="element-12391" /> Вкл
                </> : <>
                  <ToggleLeft className="w-6 h-6 text-slate-400" data-id="element-12392" /> Выкл
                </>}
            </button>
            <ChevronRight className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${!collapsedSections.contacts ? 'rotate-90' : ''}`} data-id="element-12393" />
          </div>
        </div>

        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${!collapsedSections.contacts && showContacts ? 'max-h-[1000px] mt-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-12394">
          <div className="space-y-4" data-id="element-12395">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4" data-id="element-12396">
              <div data-id="element-12397">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12398">
                  <span className="inline-flex items-center gap-1.5" data-id="element-12399">
                    <span className="w-5 h-5 rounded bg-sky-100 flex items-center justify-center text-[10px] font-bold text-sky-600" data-id="element-12400">
                      TG
                    </span>
                    Telegram
                  </span>
                </label>
                <input type="text" defaultValue="@elena_astro" placeholder="@username" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm" data-id="element-12401" />
              </div>
              <div data-id="element-12402">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12403">
                  <span className="inline-flex items-center gap-1.5" data-id="element-12404">
                    <span className="w-5 h-5 rounded bg-emerald-100 flex items-center justify-center text-[10px] font-bold text-emerald-600" data-id="element-12405">
                      WA
                    </span>
                    WhatsApp
                  </span>
                </label>
                <input type="text" defaultValue="+7 999 123-45-67" placeholder="+7 999 000-00-00" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm" data-id="element-12406" />
              </div>
              <div data-id="element-12407">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12408">
                  <span className="inline-flex items-center gap-1.5" data-id="element-12409">
                    <span className="w-5 h-5 rounded bg-pink-100 flex items-center justify-center text-[10px] font-bold text-pink-600" data-id="element-12410">
                      IG
                    </span>
                    Instagram
                  </span>
                </label>
                <input type="text" defaultValue="elena_stars" placeholder="username" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm" data-id="element-12411" />
              </div>
              <div data-id="element-12412">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12413">
                  <span className="inline-flex items-center gap-1.5" data-id="element-12414">
                    <span className="w-5 h-5 rounded bg-rose-100 flex items-center justify-center text-[10px] font-bold text-rose-600" data-id="element-12415">
                      YT
                    </span>
                    YouTube
                  </span>
                </label>
                <input type="text" defaultValue="" placeholder="Ссылка на канал" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm" data-id="element-12416" />
              </div>
              <div data-id="element-12417">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12418">
                  <span className="inline-flex items-center gap-1.5" data-id="element-12419">
                    <Globe className="w-4 h-4 text-slate-500" data-id="element-12420" />
                    Сайт
                  </span>
                </label>
                <input type="url" defaultValue="https://elena-astro.ru" placeholder="https://" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm" data-id="element-12421" />
              </div>
              <div data-id="element-12422">
                <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12423">
                  <span className="inline-flex items-center gap-1.5" data-id="element-12424">
                    <span className="w-5 h-5 rounded bg-blue-100 flex items-center justify-center text-[10px] font-bold text-blue-600" data-id="element-12425">
                      @
                    </span>
                    Email
                  </span>
                </label>
                <input type="email" defaultValue="elena@astro.ru" placeholder="email@example.com" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm" data-id="element-12426" />
              </div>
            </div>
            <p className="text-[11px] text-slate-400 pt-2" data-id="element-12427">
              Контакты отображаются на вашем публичном профиле. Оставьте поле
              пустым, чтобы скрыть.
            </p>
          </div>
        </div>
      </Card>

      {/* Услуги */}
      <Card padding="md" className={`transition-all duration-300 ${!showServices ? 'opacity-60 bg-slate-50' : ''}`} data-id="element-12428">
        <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleCollapse('services')} data-id="element-12429">
          <h3 className="font-bold text-slate-900" data-id="element-12430">Услуги</h3>
          <div className="flex items-center gap-4" data-id="element-12431">
            <button onClick={e => {
            e.stopPropagation();
            setShowServices(!showServices);
          }} className="flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-12432">
              {showServices ? <>
                  <ToggleRight className="w-6 h-6 text-emerald-500" data-id="element-12433" /> Вкл
                </> : <>
                  <ToggleLeft className="w-6 h-6 text-slate-400" data-id="element-12434" /> Выкл
                </>}
            </button>
            <ChevronRight className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${!collapsedSections.services ? 'rotate-90' : ''}`} data-id="element-12435" />
          </div>
        </div>

        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${!collapsedSections.services && showServices ? 'max-h-[1000px] mt-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-12436">
          <div className="flex justify-end mb-4" data-id="element-12437">
            <Button variant="outline" size="sm" icon={<Plus className="w-4 h-4" data-id="element-12439" />} onClick={() => {
            setServiceItems(prev => [...prev, {
              id: Date.now(),
              name: '',
              price: '',
              duration: ''
            }]);
            showToast('Новая услуга добавлена');
          }} data-id="element-12438">
              Добавить услугу
            </Button>
          </div>
          <div className="space-y-4" data-id="element-12440">
            {serviceItems.map(srv => <div key={srv.id} className="p-4 border border-slate-100 rounded-xl bg-slate-50/50" data-id="element-12441">
                <div className="flex items-start justify-between gap-4 mb-4" data-id="element-12442">
                  <div className="flex-1" data-id="element-12443">
                    <input type="text" defaultValue={srv.name} placeholder="Название услуги" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white" data-id="element-12444" />
                  </div>
                  <button onClick={() => {
                setServiceItems(prev => prev.filter(s => s.id !== srv.id));
                showToast('Услуга удалена');
              }} className="p-2.5 text-slate-400 hover:text-rose-500 hover:bg-rose-50 rounded-lg transition-colors flex-shrink-0" data-id="element-12445">
                    <Trash2 className="w-4 h-4" data-id="element-12446" />
                  </button>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12447">
                  <input type="number" defaultValue={srv.price} placeholder="Цена (₽)" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white" data-id="element-12448" />
                  <input type="text" defaultValue={srv.duration} placeholder="Длительность (60 мин, 3 дня)" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white" data-id="element-12449" />
                </div>
              </div>)}
            {serviceItems.length === 0 && <div className="text-center py-8 text-slate-400 text-sm" data-id="element-12450">
                Нет услуг. Нажмите «Добавить услугу» чтобы создать первую.
              </div>}
          </div>
        </div>
      </Card>

      {/* Образование */}
      <Card padding="md" className={`transition-all duration-300 ${!showEducation ? 'opacity-60 bg-slate-50' : ''}`} data-id="element-12451">
        <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleCollapse('education')} data-id="element-12452">
          <h3 className="font-bold text-slate-900" data-id="element-12453">Образование</h3>
          <div className="flex items-center gap-4" data-id="element-12454">
            <button onClick={e => {
            e.stopPropagation();
            setShowEducation(!showEducation);
          }} className="flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-12455">
              {showEducation ? <>
                  <ToggleRight className="w-6 h-6 text-emerald-500" data-id="element-12456" /> Вкл
                </> : <>
                  <ToggleLeft className="w-6 h-6 text-slate-400" data-id="element-12457" /> Выкл
                </>}
            </button>
            <ChevronRight className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${!collapsedSections.education ? 'rotate-90' : ''}`} data-id="element-12458" />
          </div>
        </div>

        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${!collapsedSections.education && showEducation ? 'max-h-[1000px] mt-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-12459">
          <div className="flex justify-end mb-4" data-id="element-12460">
            <Button variant="outline" size="sm" icon={<Plus className="w-4 h-4" data-id="element-12462" />} onClick={() => {
            setEducationItems(prev => [...prev, {
              id: Date.now(),
              institution: '',
              program: '',
              years: ''
            }]);
            showToast('Запись добавлена');
          }} data-id="element-12461">
              Добавить запись
            </Button>
          </div>
          <div className="space-y-4" data-id="element-12463">
            {educationItems.map(edu => <div key={edu.id} className="p-4 border border-slate-100 rounded-xl bg-slate-50/50" data-id="element-12464">
                <div className="flex items-start justify-between gap-4 mb-4" data-id="element-12465">
                  <div className="flex-1" data-id="element-12466">
                    <input type="text" defaultValue={edu.institution} placeholder="Учебное заведение" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white" data-id="element-12467" />
                  </div>
                  <button onClick={() => {
                setEducationItems(prev => prev.filter(e => e.id !== edu.id));
                showToast('Запись удалена');
              }} className="p-2.5 text-slate-400 hover:text-rose-500 hover:bg-rose-50 rounded-lg transition-colors flex-shrink-0" data-id="element-12468">
                    <Trash2 className="w-4 h-4" data-id="element-12469" />
                  </button>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-12470">
                  <input type="text" defaultValue={edu.program} placeholder="Программа / Курс" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white" data-id="element-12471" />
                  <input type="text" defaultValue={edu.years} placeholder="Годы (2016-2018)" className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white" data-id="element-12472" />
                </div>
              </div>)}
            {educationItems.length === 0 && <div className="text-center py-8 text-slate-400 text-sm" data-id="element-12473">
                Нет записей об образовании. Нажмите «Добавить запись».
              </div>}
          </div>
        </div>
      </Card>

      {/* Расписание */}
      <Card padding="md" className={`transition-all duration-300 ${!showSchedule ? 'opacity-60 bg-slate-50' : ''}`} data-id="element-12474">
        <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleCollapse('schedule')} data-id="element-12475">
          <h3 className="font-bold text-slate-900" data-id="element-12476">Расписание</h3>
          <div className="flex items-center gap-4" data-id="element-12477">
            <button onClick={e => {
            e.stopPropagation();
            setShowSchedule(!showSchedule);
          }} className="flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-12478">
              {showSchedule ? <>
                  <ToggleRight className="w-6 h-6 text-emerald-500" data-id="element-12479" /> Вкл
                </> : <>
                  <ToggleLeft className="w-6 h-6 text-slate-400" data-id="element-12480" /> Выкл
                </>}
            </button>
            <ChevronRight className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${!collapsedSections.schedule ? 'rotate-90' : ''}`} data-id="element-12481" />
          </div>
        </div>

        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${!collapsedSections.schedule && showSchedule ? 'max-h-[1000px] mt-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-12482">
          <div className="space-y-6" data-id="element-12483">
            {/* Day toggle pills */}
            <div data-id="element-12484">
              <label className="block text-sm font-medium text-slate-700 mb-3" data-id="element-12485">
                Рабочие дни
              </label>
              <div className="flex flex-wrap gap-2" data-id="element-12486">
                {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((day, i) => <button key={day} onClick={() => {
                setScheduleDays(prev => {
                  const next = [...prev];
                  next[i] = !next[i];
                  return next;
                });
              }} className={`w-12 h-12 rounded-xl text-sm font-bold transition-all ${scheduleDays[i] ? 'bg-primary text-white shadow-sm' : 'bg-slate-100 text-slate-400 hover:bg-slate-200'}`} data-id="element-12487">
                    {day}
                  </button>)}
              </div>
            </div>

            {/* Time range */}
            <div data-id="element-12488">
              <label className="block text-sm font-medium text-slate-700 mb-3" data-id="element-12489">
                Часы работы
              </label>
              <div className="flex items-center gap-3 max-w-sm" data-id="element-12490">
                <div className="flex-1" data-id="element-12491">
                  <div className="text-xs text-slate-500 mb-1.5" data-id="element-12492">С</div>
                  <select value={scheduleFrom} onChange={e => setScheduleFrom(e.target.value)} className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white font-medium" data-id="element-12493">
                    {Array.from({
                    length: 24
                  }, (_, h) => {
                    const time = `${h.toString().padStart(2, '0')}:00`;
                    return <option key={time} value={time} data-id="element-12494">
                            {time}
                          </option>;
                  })}
                  </select>
                </div>
                <div className="text-slate-300 font-bold mt-5" data-id="element-12495">—</div>
                <div className="flex-1" data-id="element-12496">
                  <div className="text-xs text-slate-500 mb-1.5" data-id="element-12497">До</div>
                  <select value={scheduleTo} onChange={e => setScheduleTo(e.target.value)} className="w-full rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white font-medium" data-id="element-12498">
                    {Array.from({
                    length: 24
                  }, (_, h) => {
                    const time = `${h.toString().padStart(2, '0')}:00`;
                    return <option key={time} value={time} data-id="element-12499">
                            {time}
                          </option>;
                  })}
                  </select>
                </div>
              </div>
            </div>

            {/* Preview */}
            <div className="bg-slate-50 rounded-xl p-4 border border-slate-100" data-id="element-12500">
              <div className="text-xs font-medium text-slate-500 mb-2" data-id="element-12501">
                Предпросмотр для клиентов:
              </div>
              <div className="text-sm text-slate-900 font-medium" data-id="element-12502">
                {scheduleDays.some(d => d) ? <>
                    {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].filter((_, i) => scheduleDays[i]).join(', ')}
                    {' · '}
                    {scheduleFrom} – {scheduleTo}
                  </> : <span className="text-slate-400" data-id="element-12503">
                    Не выбрано ни одного дня
                  </span>}
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* Частые вопросы */}
      <Card padding="md" className={`transition-all duration-300 ${!showFaq ? 'opacity-60 bg-slate-50' : ''}`} data-id="element-12504">
        <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleCollapse('faq')} data-id="element-12505">
          <h3 className="font-bold text-slate-900" data-id="element-12506">Частые вопросы</h3>
          <div className="flex items-center gap-4" data-id="element-12507">
            <button onClick={e => {
            e.stopPropagation();
            setShowFaq(!showFaq);
          }} className="flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors" data-id="element-12508">
              {showFaq ? <>
                  <ToggleRight className="w-6 h-6 text-emerald-500" data-id="element-12509" /> Вкл
                </> : <>
                  <ToggleLeft className="w-6 h-6 text-slate-400" data-id="element-12510" /> Выкл
                </>}
            </button>
            <ChevronRight className={`w-5 h-5 text-slate-400 transition-transform duration-300 ${!collapsedSections.faq ? 'rotate-90' : ''}`} data-id="element-12511" />
          </div>
        </div>

        <div className={`overflow-hidden transition-all duration-300 ease-in-out ${!collapsedSections.faq && showFaq ? 'max-h-[2000px] mt-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-12512">
          <div className="flex justify-end mb-4" data-id="element-12513">
            <Button variant="outline" size="sm" icon={<Plus className="w-4 h-4" data-id="element-12515" />} onClick={() => {
            setFaqItems(prev => [...prev, {
              id: Date.now(),
              question: '',
              answer: ''
            }]);
            showToast('Новый вопрос добавлен');
          }} data-id="element-12514">
              Добавить вопрос
            </Button>
          </div>
          <div className="space-y-4" data-id="element-12516">
            {faqItems.map(item => <div key={item.id} className="p-4 border border-slate-100 rounded-xl bg-slate-50/50" data-id="element-12517">
                <div className="mb-4" data-id="element-12518">
                  <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12519">
                    Вопрос
                  </label>
                  <div className="flex items-start gap-4" data-id="element-12520">
                    <input type="text" defaultValue={item.question} placeholder="Введите вопрос..." className="flex-1 rounded-xl border-slate-200 px-4 py-2.5 border focus:ring-primary focus:border-primary outline-none text-sm bg-white" data-id="element-12521" />
                    <button onClick={() => {
                  setFaqItems(prev => prev.filter(f => f.id !== item.id));
                  showToast('Вопрос удалён');
                }} className="p-2.5 text-slate-400 hover:text-rose-500 hover:bg-rose-50 rounded-lg transition-colors flex-shrink-0" data-id="element-12522">
                      <Trash2 className="w-4 h-4" data-id="element-12523" />
                    </button>
                  </div>
                </div>
                <div data-id="element-12524">
                  <label className="block text-sm font-medium text-slate-700 mb-1.5" data-id="element-12525">
                    Ответ
                  </label>
                  <textarea className="w-full rounded-xl border-slate-200 px-4 py-3 border focus:ring-primary focus:border-primary outline-none text-sm bg-white" rows={3} defaultValue={item.answer} placeholder="Введите ответ..." data-id="element-12526" />
                </div>
              </div>)}
            {faqItems.length === 0 && <div className="text-center py-8 text-slate-400 text-sm" data-id="element-12527">
                Нет вопросов. Нажмите «Добавить вопрос» чтобы создать первый.
              </div>}
          </div>
        </div>
      </Card>

      {/* Верификация профиля */}
      <Card padding="md" className="border-indigo-100 bg-indigo-50/30" data-id="element-12528">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-5" data-id="element-12529">
          <div data-id="element-12530">
            <h3 className="font-bold text-slate-900 flex items-center gap-2" data-id="element-12531">
              <ShieldCheck className="w-5 h-5 text-indigo-500" data-id="element-12532" />
              Верификация профиля
            </h3>
            <p className="text-xs sm:text-sm text-slate-600 mt-1" data-id="element-12533">
              Верификация занимает 1-3 рабочих дня. Верифицированные профили
              получают значок PRO.
            </p>
          </div>

          {verificationStatus === 'unverified' && <Badge variant="warning" className="flex items-center gap-1 flex-shrink-0" data-id="element-12534">
              <AlertCircle className="w-3.5 h-3.5" data-id="element-12535" /> Не верифицирован
            </Badge>}
          {verificationStatus === 'pending' && <Badge variant="pro" className="flex items-center gap-1 flex-shrink-0" data-id="element-12536">
              <Clock className="w-3.5 h-3.5" data-id="element-12537" /> На проверке
            </Badge>}
          {verificationStatus === 'verified' && <Badge variant="success" className="flex items-center gap-1 flex-shrink-0" data-id="element-12538">
              <CheckCircle className="w-3.5 h-3.5" data-id="element-12539" /> Верифицирован
            </Badge>}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-5" data-id="element-12540">
          {[{
          icon: FileCheck,
          title: 'Паспорт / ID',
          desc: 'Подтверждение личности'
        }, {
          icon: GraduationCap,
          title: 'Диплом / Сертификат',
          desc: 'Подтверждение квалификации'
        }, {
          icon: FileText,
          title: 'Доп. документы',
          desc: 'Отзывы, сертификаты'
        }].map(doc => <div key={doc.title} className="border-2 border-dashed border-slate-300 rounded-xl p-4 sm:p-6 text-center hover:bg-white transition-colors cursor-pointer bg-slate-50/50" data-id="element-12541">
              <doc.icon className="w-7 h-7 text-slate-400 mx-auto mb-2" data-id="element-12542" />
              <div className="text-sm font-bold text-slate-900 mb-0.5" data-id="element-12543">
                {doc.title}
              </div>
              <div className="text-[11px] text-slate-500 mb-3" data-id="element-12544">{doc.desc}</div>
              <Button variant="outline" size="sm" icon={<Upload className="w-3 h-3" data-id="element-12546" />} data-id="element-12545">
                Загрузить
              </Button>
            </div>)}
        </div>

        <div className="flex justify-end" data-id="element-12547">
          <Button variant="primary" disabled={verificationStatus === 'pending' || verificationStatus === 'verified'} onClick={() => {
          setVerificationStatus('pending');
          showToast('Документы отправлены на проверку ✓');
        }} data-id="element-12548">
            {verificationStatus === 'unverified' ? 'Отправить на проверку' : verificationStatus === 'pending' ? 'На проверке...' : 'Верифицирован ✓'}
          </Button>
        </div>
      </Card>

      <div className="flex justify-end pt-3 border-t border-slate-200" data-id="element-12549">
        <Button variant="primary" size="lg" onClick={() => showToast('Изменения сохранены ✓')} data-id="element-12550">
          Сохранить изменения
        </Button>
      </div>
    </div>;
}